import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {ReviewDetailData} from "../models/review-detail-data";
import {ReviewResponse} from "../models/review-response";
import {SequenceResponse} from "../models/sequence-response";

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor(private http: HttpClient) {
    }

    getDetailedData(locationId: string, pageNumber = 0, filterValue = 'all', startDate: string, endDate: string) {
        return this.http.get<ReviewDetailData>(`${environment.BASE_URL}analytics/getDetailedData?filterValue=${filterValue}&locationId=${locationId}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`);
    }

    getReviewData(locationId: string, startDate: string, endDate: string) {
        return this.http.get<ReviewResponse>(`${environment.BASE_URL}analytics/getReviewData?endDate=${endDate}&locationId=${locationId}&startDate=${startDate}`);
    }

    getSequenceData(locationId: string, startDate: string, endDate: string) {
        return this.http.get<SequenceResponse[]>(`${environment.BASE_URL}analytics/getSequenceData?endDate=${endDate}&locationId=${locationId}&startDate=${startDate}`);
    }
}
